import { useQueryClient } from '@tanstack/react-query'
import { statisticsWidgetsQueryOptions } from 'hook/query/useGetStatisticsWidgets'
import { useEffect, useState } from 'react'
import { useAppDispatch } from 'store/hooks'
import { notifyUser } from 'store/notificationsSlice'

/**
 * Prefetch тяжёлых запросов дашборда перед рендером виджетов.
 * Гарантирует 1 запрос statistics вместо N при первом заходе на страницу.
 * При ошибке бэкенда показывает уведомление и всё равно рендерит дашборд.
 *
 * @returns isReady — true когда prefetch завершён (успешно или с ошибкой), виджеты можно рендерить
 */
export const useDashboardDataPrefetch = () => {
	const queryClient = useQueryClient()
	const dispatch = useAppDispatch()
	const [isReady, setIsReady] = useState(false)

	useEffect(() => {
		let isMounted = true

		const prefetch = async () => {
			try {
				await queryClient.prefetchQuery(statisticsWidgetsQueryOptions)
			} catch (error) {
				dispatch(
					notifyUser({
						title: 'Не удалось загрузить данные фермы',
						description:
							error instanceof Error
								? error.message
								: 'Произошла ошибка при загрузке',
						isError: true,
					}),
				)
			} finally {
				if (isMounted) {
					setIsReady(true)
				}
			}
		}

		prefetch()
		return () => {
			isMounted = false
		}
	}, [queryClient, dispatch])

	return { isReady }
}
